"use strict";
/**
 * Encore Foundation - 7.11.0
 *
 * The contents of this file is owned and generated by the Encore team.
 * If you need to make changes to the values stored here please reach out
 * to #encore on Slack.
 *
 * Links:
 *
 * - Source & Documentation: https://ghe.spotify.net/encore/foundation
 *
 * Tack!
 *
 * Encore
 * encore.spotify.net
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.campaign = exports.category = exports.theme = exports.spacer = exports.breakpoint = exports.opacity = exports.color = void 0;
__exportStar(require("./colors"), exports);
__exportStar(require("./opacities"), exports);
__exportStar(require("./breakpoints"), exports);
__exportStar(require("./spacers"), exports);
__exportStar(require("./mobileTypography"), exports);
__exportStar(require("./desktopTypography"), exports);
__exportStar(require("./themes"), exports);
__exportStar(require("./categorySets"), exports);
__exportStar(require("./campaignSets"), exports);
__exportStar(require("./textStyles"), exports);
var color = require("./colors");
exports.color = color;
var opacity = require("./opacities");
exports.opacity = opacity;
var breakpoint = require("./breakpoints");
exports.breakpoint = breakpoint;
var spacer = require("./spacers");
exports.spacer = spacer;
var theme = require("./themes");
exports.theme = theme;
var category = require("./categorySets");
exports.category = category;
var campaign = require("./campaignSets");
exports.campaign = campaign;
